import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authAPI.forgotPassword({ email });
      setEmailSent(true);
      toast.success('Password reset instructions have been sent to your email!');
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to send reset email';
      toast.error(errorMsg);
      console.error('Forgot password error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <ToastContainer position="top-right" autoClose={3000} theme="dark" />
        
        <div style={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #333',
          borderRadius: '12px',
          padding: '40px',
          width: '100%',
          maxWidth: '450px',
          boxShadow: '0 10px 40px rgba(255, 182, 193, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>📧</div>
          <h1 style={{ 
            fontSize: '1.8rem', 
            fontWeight: '600', 
            marginBottom: '15px',
            color: '#ffffff'
          }}>
            Check Your Email
          </h1>
          <p style={{ color: '#999', fontSize: '1rem', marginBottom: '30px', lineHeight: '1.6' }}>
            If an account exists with <strong style={{ color: '#FFB6C1' }}>{email}</strong>, 
            you will receive password reset instructions shortly.
          </p>
          <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '20px' }}>
            Didn't receive the email? Check your spam folder.
          </p>
          <Link 
            to="/login"
            style={{
              display: 'inline-block',
              padding: '12px 30px',
              backgroundColor: '#FFB6C1',
              color: '#000000',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem'
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      
      <div style={{
        backgroundColor: '#1a1a1a',
        border: '1px solid #333',
        borderRadius: '12px',
        padding: '40px',
        width: '100%',
        maxWidth: '450px',
        boxShadow: '0 10px 40px rgba(255, 182, 193, 0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔒</div>
          <h1 style={{ 
            fontSize: '2rem', 
            fontWeight: '600', 
            marginBottom: '10px',
            color: '#ffffff'
          }}>
            Forgot Password?
          </h1>
          <p style={{ color: '#999', fontSize: '0.95rem' }}>
            Enter your email and we'll send you instructions to reset your password
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              📧 Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your.email@example.com"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#FFB6C1',
              color: '#000000',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.2s',
              marginBottom: '15px'
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ 
          textAlign: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #333'
        }}>
          <Link 
            to="/login" 
            style={{ 
              color: '#FFB6C1', 
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '0.9rem'
            }}
          >
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
